var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasBanners
    ? _c(
        "div",
        { class: _vm.classes },
        [
          _c(
            "vue-client-only",
            [
              _vm.isSliderMode
                ? _c("swiper", {
                    attrs: {
                      items: _vm.BANNERS,
                      dots: "",
                      "slides-to-show": 2
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("banner", {
                                attrs: { data: item, "slot-name": _vm.slotName }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1322413690
                    )
                  })
                : _c(
                    "div",
                    { staticClass: "banners-slot__wrap" },
                    _vm._l(_vm.BANNERS, function(banner) {
                      return _c("banner", {
                        key: banner.id,
                        attrs: { data: banner, "slot-name": _vm.slotName }
                      })
                    }),
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }